<template>
    <v-container
        fluid
        class="device-setup-splash fill-height pa-4 pa-sm-6"
    >
        <v-row
            align="center"
            justify="center"
            class="fill-height"
        >
            <v-col
                cols="12"
                sm="10"
                md="6"
                lg="4"
                xl="3"
            >
                <v-card
                    :elevation="isMobileSize() ? 0 : 2"
                    :outlined="isMobileSize()"
                    class="device-setup-card pa-4 pa-sm-6"
                >
                    <div class="text-center mb-6">
                        <v-avatar
                            color="primary"
                            size="56"
                            class="mb-4"
                        >
                            <v-icon dark large>mdi-cellphone-cog</v-icon>
                        </v-avatar>
                        <h2 class="text-h5 text-sm-h4 font-weight-medium mb-2">
                            {{ $t('DeviceSetup.title') }}
                        </h2>
                        <p class="text-body-2 text--secondary mb-0">
                            {{ $t('DeviceSetup.subtitle') }}
                        </p>
                    </div>

                    <div class="mb-6">
                        <div class="d-flex align-center mb-2">
                            <v-avatar
                                :color="hardwareSelected ? 'primary' : undefined"
                                :class="hardwareSelected ? '' : 'grey lighten-3'"
                                size="28"
                                class="mr-3 flex-grow-0"
                            >
                                <span
                                    class="text-caption font-weight-bold"
                                    :class="hardwareSelected ? 'white--text' : 'grey--text text--darken-2'"
                                >1</span>
                            </v-avatar>
                            <span class="text-subtitle-2">
                                {{ $t('DeviceSetup.step_device') }}
                            </span>
                        </div>
                        <HardwareSelector />
                    </div>

                    <div class="mb-4">
                        <div class="d-flex align-center mb-2">
                            <v-avatar
                                :color="deviceSetupComplete ? 'primary' : undefined"
                                :class="deviceSetupComplete ? '' : 'grey lighten-3'"
                                size="28"
                                class="mr-3 flex-grow-0"
                            >
                                <span
                                    class="text-caption font-weight-bold"
                                    :class="deviceSetupComplete ? 'white--text' : 'grey--text text--darken-2'"
                                >2</span>
                            </v-avatar>
                            <span class="text-subtitle-2">
                                {{ $t('DeviceSetup.step_firmware') }}
                            </span>
                        </div>
                        <VersionSelector :hideInfo="isMobileSize()" />
                    </div>

                    <v-alert
                        v-if="!deviceSetupComplete"
                        type="info"
                        dense
                        text
                        class="mb-4"
                    >
                        {{ setupHint }}
                    </v-alert>

                    <v-btn
                        block
                        large
                        color="primary"
                        :disabled="!deviceSetupComplete"
                        @click="$emit('continue')"
                    >
                        {{ $t('DeviceSetup.continue') }}
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import HardwareSelector from '@/components/HardwareSelector.vue'
import VersionSelector from '@/components/VersionSelector.vue'

export default {
    components: {
        HardwareSelector,
        VersionSelector
    },
    computed: {
        hardwareSelected() {
            return this.$store.getters.selectedHardwareVersion != null
        },
        deviceSetupComplete() {
            return this.$store.getters.deviceSetupComplete
        },
        setupHint() {
            if (!this.hardwareSelected) {
                return this.$t('DeviceSetup.hint_device')
            }
            return this.$t('DeviceSetup.hint_firmware')
        }
    }
}
</script>

<style scoped>
.device-setup-splash {
    min-height: calc(100vh - 120px);
}
.device-setup-card {
    border-top: 4px solid var(--v-primary-base, #5867dd);
}
</style>
